import axios from 'axios';
import { logoutUser } from '../ReduxStore/userReducer';
import { resetItemGroup, resetItems } from '../ReduxStore/actions';

export const PostData = async (PostAPI, data, jwtToken, dispatch, navigate) => {
    // Function to extract error messages from nested error objects
    const extractErrorMessage = (errorObject) => { 
    if (!errorObject) return "An unknown error occurred.";

    if (typeof errorObject === 'string') {
        return errorObject;
    }

    // Handle if the error object is actually an array of errors
    if (Array.isArray(errorObject)) {
        return errorObject[0]; // Return the first error message
    }

    // Handle if it's an object
    if (typeof errorObject === 'object') {
        // 1. Look for keys that start with "$."
        for (const key in errorObject) {
            if (errorObject.hasOwnProperty(key)) {
                if (key.startsWith('$.')) {
                    return errorObject[key][0]; // Return the first error from this key
                }
            }
        }

        // 2. If not found, recursively inspect the object and its properties
        for (const key in errorObject) {
            if (errorObject.hasOwnProperty(key)) {
                const nestedError = extractErrorMessage(errorObject[key]);
                if (nestedError) {
                    return nestedError; // Return the first valid error message found
                }
            }
        }

        // 3. If all else fails, convert the object into a string representation
        return JSON.stringify(errorObject); // Safely stringify the object if no error message found
    }

    return "An unknown error occurred.";
}
    // const extractErrorMessage = (errorObject) => {
    //     if (!errorObject) return "An unknown error occurred.";
    //     if (typeof errorObject === 'string') {
    //     return errorObject;      
    //     }
    //     // 1. Check if there are any errors starting with '$.' first
    //     if (typeof errorObject === 'object') {
    //         // Look through all keys in the error object
    //         for (const key in errorObject) {
    //             // Check if the key starts with "$."
    //             if (key.startsWith('$.') && errorObject.hasOwnProperty(key)) {
    //                 return errorObject[key][0]; // Return the first error message from that key
    //             }else {
    //                 return errorObject;
    //             }
    //         }
    //     }
    
    //     // 2. If it's an array, return the first error message in the array
    //     if (Array.isArray(errorObject)) {
    //         return errorObject[0]; // Return the first error message in the array
    //     }
    
    //     // 3. If it's an object, recurse through its properties
    //     if (typeof errorObject === 'object') {
    //         for (const key in errorObject) {
    //             if (errorObject.hasOwnProperty(key)) {
    //                 const nestedError = extractErrorMessage(errorObject[key]);
    //                 if (nestedError) {
    //                     return nestedError; // Return the first valid error message found
    //                 }
    //             }
    //         }
    //     }
    
    //     return "An unknown error occurred."; // fallback if no message is found
    // };
    try {
        const response = await axios.post(PostAPI, data, {
            headers: {
                'wg_token': jwtToken,
            },
        });
        return response.data;
    } catch (error) {
        if (error.response && error.response.data) {
            // Extract the first error message dynamically
            const errorMessage = extractErrorMessage(error.response.data.errors || error.response.data);
            // Handle specific error cases, e.g., 401 Unauthorized
            if (error.response.status === 401 || error.response.data === 'Invalid token') {
                dispatch(logoutUser());
                dispatch(resetItemGroup());
                dispatch(resetItems());
                navigate('/');
            }

            throw new Error(errorMessage); // re-throw with the extracted message
        } else {
            // Handle unexpected errors
            console.error("Unexpected error:", error);
            throw new Error("An unexpected error occurred.");
        }
    }
};
export const PostWithoutData = async (PostAPI, jwtToken, dispatch, navigate) => {
        try {
            const response = await axios.post(PostAPI,null, {
                headers: {
                    'wg_token': jwtToken,
                },
            });
            return response.data;
        } catch (error) {
            if (error.response && (error.response.status === 401 || error.response.data === 'Invalid token')) {
                dispatch(logoutUser());
                dispatch(resetItemGroup());
                dispatch(resetItems());
                navigate('/');
            }
            throw error;
        }
    };
    
